// import bracelets from "../../images/circleIcons/equalibrium/bracelets.png";
// import icecream from "../../images/circleIcons/equalibrium/Icecream.png";
// import silver from "../../images/circleIcons/equalibrium/silver.png";
// import avocado from "../../images/circleIcons/equalibrium/avocado.png";
// import vase from "../../images/circleIcons/equalibrium/vase.png";
// import gaming from "../../images/circleIcons/equalibrium/gaming.png";
// import soda from "../../images/circleIcons/equalibrium/soda.png";
// import alcohol from "../../images/circleIcons/equalibrium/alcohol.png";
// import physicians from "../../images/circleIcons/equalibrium/physicians.png";
// import chapstick from "../../images/circleIcons/equalibrium/chapstick.png";
// import eCigarettes from "../../images/circleIcons/equalibrium/eCigarettes.png";
// import eyeSurgery from "../../images/circleIcons/equalibrium/eyeSurgery.png";
// import oil from "../../images/circleIcons/equalibrium/oil.png";

import Panettone from "../../images/circleIcons/equalibrium/Panettone.png";
import Puppets from "../../images/circleIcons/equalibrium/Puppets.png";
import Stuffers from "../../images/circleIcons/equalibrium/Stuffers.png";
import Stars from "../../images/circleIcons/equalibrium/Stars.png";
import Trees from "../../images/circleIcons/equalibrium/Trees.png";
import Menorah from "../../images/circleIcons/equalibrium/Menorah.png";
import Wreaths from "../../images/circleIcons/equalibrium/Wreaths.png";
import Plane from "../../images/circleIcons/equalibrium/Plane.png";
import Skating from "../../images/circleIcons/equalibrium/Skating.png";
import Music from "../../images/circleIcons/equalibrium/Music.png";
import Calendar from "../../images/circleIcons/equalibrium/calendar.png";
import Decorations from "../../images/circleIcons/equalibrium/decorations.png";

const questionAnswers = [
  {
    title: "MARKET FOR PANETTONE",
    question:
      "The price of dried fruit, a key ingredient in the traditional Italian Christmas cake Panettone, increases.",
    subQuestion: "Consider the market for Panettone. What happens?",
    icon: Panettone,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "If the price of dried fruit, an input for Panettone, increases, the cost of producing this cake increases. Therefore, the supply of Panettone decreases, represented by a shift of the supply curve for Panettone to the left.",
  },
  {
    title: "MARKET FOR FINGER PUPPETS",
    question:
      "A new study finds that finger puppets increase curiosity and learning for children aged 2-3, encouraging young parents to choose this toy as a holiday gift.",
    subQuestion:
      "Consider the market for Paw Patrol finger puppets. What happens?",
    icon: Puppets,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "The positive effect of finger puppers on child learning increases the number of parents who are willing to buy this toy for their children. Therefore, the demand for these finger puppets increases, represented by a shift of the demand curve for finger puppets to the right.",
  },
  {
    title: "MARKET FOR PLASTIC CHRISTMAS STARS",
    question:
      "The government starts taxing producers of plastic Christmas items.",
    subQuestion:
      "Consider the market for plastic Christmas stars. What happens?",
    icon: Stars,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "A tax imposed on producers of items made of plastic resembles an increase in the cost of production for these firms, and thus, discourages production. Therefore, the supply of plastic Christmas stars decreases, represented by a shift of the supply curve for plastic Christmas stars to the left.",
  },

  {
    title: "MARKET FOR CHRISTMAS TREES",
    question:
      "Wildfires and a heat wave destroy about 90% of Christmas tree crops in Oregon, one of the largest growers of Christmas trees in the U.S.",
    subQuestion: "Consider the market for Christmas trees. What happens?",
    icon: Trees,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "If natural disasters destroy Christmas tree crops, the supply of Christmas trees decreases, represented by a shift of the supply curve for Christmas trees to the left.",
  },

  {
    title: "MARKET FOR BRASS MENORAHS",
    question:
      "Prices of silver menorahs soar due to an increase in the price of silver.",
    subQuestion: "Consider the market for brass menorahs. What happens?",
    icon: Menorah,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "Silver and brass menorahs are substitutes. When silver menorahs become more expensive, the quantity demanded of the good decreases, while consumers become more interested in the substitutes of silver menorahs. Therefore, the demand for brass menorahs increases, represented by a shift of the demand curve for brass menorahs to the right.",
  },

  {
    title: "MARKET FOR CHRISTMAS WREATHS",
    question:
      "Restaurants are struggling to find workers for the approaching holiday season.",
    subQuestion: "Consider the market for Christmas wreaths. What happens?",
    icon: Wreaths,
    answer: "Nothing happens",
    graphType: "supply curve",
    briefness:
      "There is no obvious connection between restaurant meals and wreaths. Therefore, there is no shift in the market for wreaths.",
  },

  {
    title: "MARKET FOR PLANE TICKETS",
    question:
      "After staying home last holiday season due to lockdowns and fear of COVID-19, families are now more eager to travel than ever.",
    subQuestion: "Consider the market for plane tickets. What happens?",
    icon: Plane,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "If more families are willing and able to travel, more plane tickets are needed. Therefore, the demand for plane tickets increases, represented by a shift of the demand curve for plane tickets to the right.",
  },

  {
    title: "MARKET FOR OUTDOOR ICE SKATING RINKS",
    question:
      "New technology reduces the cost of maintaining outdoor ice skating rinks for the holidays.",
    subQuestion:
      "Consider the market for outdoor ice skating rinks. What happens?",
    icon: Skating,
    answer: "Supply curve shifts right",
    graphType: "supply curve",
    briefness:
      "The new technology lowers the costs of maintaing outdoor ice skating rinks, reducing the cost to the providers of ice skating services. Therefore, the supply of outdoor ice skating rinks increases, represented by a shift of the supply curve to the right.",
  },
  {
    title: "MARKET FOR HOLIDAY DECORATION SERVICES",
    question:
      "A recent survey shows that businesses increasingly prefer to decorate their offices for the holidays on their own, rather than hiring outside decoration services.",
    subQuestion:
      "Consider the market for holiday decoration services. What happens?",
    icon: Decorations,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "If more consumers of holiday decoration services now prefer to decorate on their own now, the demand for decoration services decreases, represented by a shift of the demand curve for holiday decoration services to the left.",
  },
  {
    title: "MARKET FOR ADVENT CALENDARS",
    question:
      "Two months before Christmas, families expect that the price of advent calendars counting the last 30 days until Christmas will increase a month before the holiday.",
    subQuestion:
      "Consider the market for advent calendars two months before Christmas. What happens?",
    icon: Calendar,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "If families expect that the price of advent calendars will increase in the future, they would prefer to buy calendars now, before the price goes up. Therefore, the demand for advent calendars increases two months before Christmas, represented by a shift of the demand curve for advent calendars to the right.",
  },
];

export default questionAnswers;
